import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

type ClientGoalsCardProps = {
  goalItems: Array<{ key: string; label: string; value: string }>;
  mealSlotTargetsSummary?: string;
};

const ClientGoalsCard: React.FC<ClientGoalsCardProps> = ({
  goalItems,
  mealSlotTargetsSummary,
}) => {
  if (!goalItems.length && !mealSlotTargetsSummary) {
    return null;
  }

  return (
    <Card className="border-blue-200">
      <CardHeader>
        <CardTitle>Client Nutritional Goals</CardTitle>
      </CardHeader>
      <CardContent>
        {goalItems.length > 0 && (
          <div className="grid grid-cols-5 gap-3">
            {goalItems.map((item) => (
              <div
                key={item.key}
                className="text-center py-2 px-1 bg-gray-50 rounded-lg border border-gray-200"
              >
                <div className="text-xs text-gray-500 mb-0.5">{item.label}</div>
                <div className="text-base font-semibold text-gray-900">
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        )}

        {mealSlotTargetsSummary && (
          <div className={`${goalItems.length > 0 ? 'mt-4' : ''} rounded-lg border border-blue-200 bg-blue-50 p-3`}>
            <p className="text-sm text-blue-900">
              <span className="font-semibold">Meal Slot Targets:</span> {mealSlotTargetsSummary}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ClientGoalsCard;
